import Immutable from 'immutable'
import { actionTypes } from 'actions/actionTypes'

export const initialState = () => Immutable.fromJS({
  orderSkip: {
    triggered: false,
    modalVisibility: false,
    orderId: '',
    deliveryDayId: '',
    boxNumber: '',
    orderType: '',
    orderDate: '',
    title: '',
    modalType: 'order',
    offer: null,
    valueProposition: null,
    callToActions: null,
    forceRefresh: false,
    promoCode: null,
  },
  subscriptionPause: {
    triggered: false,
    modalVisibility: false,
    modalType: 'subscription',
    pauseReason: '',
    title: '',
    callToActions: null,
    offers: null,
    promoCode: null,
  },
})

export const onScreenRecoveryReducers = {
  onScreenRecovery: (state, action) => {
    if (!state) {
      return initialState()
    }

    switch (action.type) {
    case actionTypes.ORDER_SKIP_RECOVERY_TRIGGERED: {
      /**
       * triggered: set the modal to open/close
       * modalVisibility(deprecated): used to be used to prevent
       * order skip discount to be shown on subs. pause and vise versa
       * when modal is closed it sets modalVisibility to false
       * which will reset the state to use initialState
       */
      const newState = state.set('orderSkip', Immutable.fromJS({
        triggered: action.triggered,
        modalVisibility: action.modalVisibility,
        orderId: action.orderId,
        deliveryDayId: action.deliveryDayId,
        boxNumber: action.boxNumber,
        orderType: action.orderType,
        orderDate: action.orderDate,
        title: action.title,
        modalType: 'order',
        offer: action.offer,
        valueProposition: action.valueProposition,
        callToActions: action.callToActions,
        forceRefresh: action.forceRefresh,
        promoCode: action.promoCode,
      }))

      return newState
    }

    case actionTypes.SUB_PAUSE_RECOVERY_TRIGGERED: {
      /**
       * triggered: set the modal to open/close
       * modalVisibility(deprecated): used to be used to prevent
       * order skip discount to be shown on subs. pause and vise versa
       * when modal is closed it sets modalVisibility to false
       * which will reset the state to use initialState
       */
      const newState = state.set('subscriptionPause', Immutable.fromJS({
        triggered: action.triggered,
        modalVisibility: action.modalVisibility,
        modalType: 'subscription',
        title: action.title,
        callToActions: action.callToActions,
        offers: action.offers,
        promoCode: action.promoCode,
      }))

      return newState
    }

    case actionTypes.ORDER_SKIP_RECOVERY_MODAL_VISIBILITY_CHANGE: {
      let newState = state
      if (action.modalVisibility) {
        if (action.orderId) {
          newState = newState.setIn(['orderSkip', 'orderId'], action.orderId)
        }

        if (action.deliveryDayId) {
          newState = newState.setIn(['orderSkip', 'deliveryDayId'], action.deliveryDayId)
        }

        if (action.modalType) {
          newState = newState.setIn(['orderSkip', 'modalType'], action.modalType)
        }

        if (action.title) {
          newState = newState.setIn(['orderSkip', 'title'], action.title)
        }

        if (action.cmsVariation) {
          newState = newState.setIn(['orderSkip', 'cmsVariation'], action.cmsVariation)
        }

        if (action.offer && action.offer.details) {
          newState = newState.setIn(['orderSkip', 'offer'], Immutable.fromJS({
            ...action.offer.details,
            promoCode: action.offer.promoCode
          }))
        }

        if (action.promoCode) {
          newState = newState.setIn(['orderSkip', 'promoCode'], action.promoCode)
        }

        if (action.valueProposition) {
          newState = newState.setIn(['orderSkip', 'valueProposition'], action.valueProposition)
        }

        if (action.callToActions) {
          newState = newState.setIn(['orderSkip', 'callToActions'], Immutable.fromJS(action.callToActions))
        }

        if (action.orderType) {
          newState = newState.setIn(['orderSkip', 'orderType'], action.orderType)
        }

        newState = newState.setIn(['orderSkip', 'modalVisibility'], action.modalVisibility)
      } else {
        newState = initialState()
      }

      return newState
    }

    case actionTypes.SUBSCRIPTION_PAUSE_OSR_REASON_SELECTED: {
      return state.setIn(['subscriptionPause', 'pauseReason'], action.pauseReason)
    }

    default: {
      return state
    }
    }
  }
}
